module.exports = __webpack_public_path__ + "img/team-member-08.7f18ca6d.jpg";